// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__15lHG","inputWrap":"Table_inputWrap__1OZDA","col":"Table_col__2WnSu","bmiTooltip":"Table_bmiTooltip__2ZmYX"};